<template>
  <div class="p-8">
    <!-- Amis -->
    <div class="mb-10">
      <h1 class="text-2xl font-bold mb-4">Mes amis</h1>
      <div class="space-y-4">
        <div v-if="!friends.length">Aucun ami ajouté pour le moment</div>
        <v-menu v-for="user in friends" :key="user.id" v-model="menuStates[user.id]">
          <template v-slot:activator="{props}">
            <div
              class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
              v-bind="props"
            >
              <div class="flex items-center ml-1">
                <v-badge dot location="bottom end" :color="user?.online ? statusColors[user.dot] : statusColors[3]">
                  <v-img
                    class="h-12 w-12 rounded-full"
                    :src="'https://api.baranimes.com/images/minia/minori.png'"
                    style="
                      background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                        linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
                    "
                  ></v-img>
                </v-badge>

                <span class="text-[1rem] ml-3">{{ user.name }}</span>
              </div>
              <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
                <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="M12 14.975q-.2 0-.375-.062T11.3 14.7l-4.6-4.6q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l3.9 3.9l3.9-3.9q.275-.275.7-.275t.7.275t.275.7t-.275.7l-4.6 4.6q-.15.15-.325.213t-.375.062"
                />
              </svg>
            </div>
          </template>

          <v-card
            min-width="300"
            style="background: rgb(34 43 64); border-radius: 1.5rem; backdrop-filter: blur(10px)"
            class="p-4 text-white flex flex-col gap-2"
          >
            <div
              @click="openProfile(user.url)"
              class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
            >
              <div class="flex items-center ml-1">
                <svg
                  class="mr-2 opacity-80"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="currentColor"
                    d="M5.85 17.1q1.275-.975 2.85-1.537T12 15t3.3.563t2.85 1.537q.875-1.025 1.363-2.325T20 12q0-3.325-2.337-5.663T12 4T6.337 6.338T4 12q0 1.475.488 2.775T5.85 17.1M12 13q-1.475 0-2.488-1.012T8.5 9.5t1.013-2.488T12 6t2.488 1.013T15.5 9.5t-1.012 2.488T12 13m0 9q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22"
                  />
                </svg>
                <span class="text-sm font-semibold">Profil</span>
              </div>
              <div class="flex gap-2"></div>
            </div>
            <div
              @click="changeStatus(1)"
              class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
              :class="{disabled: global.joinRoom}"
            >
              <div class="flex items-center ml-1">
                <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    class="text-[#90ee90]"
                  >
                    <!-- Icon from Material Symbols Light by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                    <path
                      fill="currentColor"
                      d="m18.839 20.696l-3.06-3.054l-1.923 1.924q-.102.101-.277.101t-.277-.102q-.46-.46-.46-1.136q0-.677.46-1.137l4.09-4.09q.46-.46 1.137-.46t1.137.46q.101.102.101.277t-.101.277l-1.924 1.923l3.054 3.06q.243.242.243.565t-.243.565l-.827.827q-.242.242-.565.242t-.565-.242M20.758 5.72l-10.8 10.82l.74.734q.46.46.46 1.137t-.46 1.136q-.102.102-.277.102t-.277-.102l-1.923-1.923l-3.06 3.054q-.242.242-.565.242t-.565-.242l-.827-.827q-.242-.242-.242-.565t.242-.566l3.054-3.06l-1.923-1.922q-.102-.102-.102-.277t.102-.277q.46-.46 1.136-.46q.677 0 1.137.46l.754.76L17.944 3.378q.218-.217.522-.348t.628-.131h1.098q.348 0 .578.23t.23.578v1.44q0 .162-.056.301t-.186.27M7.09 9.586l-3.63-3.63q-.218-.218-.339-.522T3 4.806V3.708q0-.349.23-.578t.578-.23h1.098q.323 0 .628.13q.305.131.522.349l3.611 3.63q.224.224.224.53t-.224.53L8.19 9.586q-.223.224-.55.224t-.548-.223"
                    />
                  </svg>
                </div>
                <span class="text-sm font-semibold text-[#90ee90]">Faire un duel</span>
              </div>
              <div class="flex gap-2"></div>
            </div>
            <div
              @click="changeStatus(1)"
              class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer disabled"
            >
              <div class="flex items-center ml-1">
                <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    class="text-[#90ee90]"
                  >
                    <!-- Icon from Remix Icon by Remix Design - https://github.com/Remix-Design/RemixIcon/blob/master/License -->
                    <path
                      fill="currentColor"
                      d="M10 11V8l5 4l-5 4v-3H1v-2zm-7.542 4h2.124A8.003 8.003 0 0 0 20 12A8 8 0 0 0 4.582 9H2.458C3.732 4.943 7.522 2 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-4.478 0-8.268-2.943-9.542-7"
                    />
                  </svg>
                </div>
                <span class="text-sm font-semibold text-[#90ee90]">Rejoindre la partie</span>
              </div>
              <div class="flex gap-2"></div>
            </div>
            <div
              @click="changeStatus(1)"
              class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
              :class="{disabled: !global.joinRoom}"
            >
              <div class="flex items-center ml-1">
                <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="32"
                    height="32"
                    viewBox="0 0 24 24"
                    class="text-[#90ee90]"
                  >
                    <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
                    <path
                      fill="currentColor"
                      d="M12 12.75c1.63 0 3.07.39 4.24.9c1.08.48 1.76 1.56 1.76 2.73V18H6v-1.61c0-1.18.68-2.26 1.76-2.73c1.17-.52 2.61-.91 4.24-.91M4 13c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1c-.99 0-1.93.21-2.78.58A2.01 2.01 0 0 0 0 16.43V18h4.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85A6.95 6.95 0 0 0 20 14c-.39 0-.76.04-1.13.1c.4.68.63 1.46.63 2.29V18H24zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3s-3-1.34-3-3s1.34-3 3-3"
                    />
                  </svg>
                </div>
                <span class="text-sm font-semibold text-[#90ee90]">Inviter dans la partie</span>
              </div>
              <div class="flex gap-2"></div>
            </div>
            <v-dialog max-width="550">
              <template v-slot:activator="{props: activatorProps}">
                <div
                  v-bind="activatorProps"
                  class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow cursor-pointer"
                >
                  <div class="flex items-center ml-1">
                    <div class="w-[24px] h-[24px] flex items-center mr-2 justify-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        class="text-[#f54f67]"
                      >
                        <!-- Icon from Google Material Icons by Material Design Authors - https://github.com/material-icons/material-icons/blob/master/LICENSE -->
                        <path
                          fill="currentColor"
                          d="M14 8c0-2.21-1.79-4-4-4S6 5.79 6 8s1.79 4 4 4s4-1.79 4-4M2 18v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4s-8 1.34-8 4m16-8h4c.55 0 1 .45 1 1s-.45 1-1 1h-4c-.55 0-1-.45-1-1s.45-1 1-1"
                        />
                      </svg>
                    </div>
                    <span class="text-sm font-semibold text-[#f54f67]">Retirer des amis</span>
                  </div>
                  <div class="flex gap-2"></div>
                </div>
              </template>

              <template v-slot:default="{isActive}">
                <div class="rounded-2xl bg-radiant text-white shadow-2xl">
                  <v-card-title class="font-semibold text-2xl mt-2 text-center">
                    Confirmer la suppression
                  </v-card-title>

                  <v-card-actions class="justify-center">
                    <v-btn text @click="isActive.value = false"> Annuler </v-btn>
                    <v-btn color="#f54f67" @click="removeFriend(user)"> Supprimer </v-btn>
                  </v-card-actions>
                </div>
              </template>
            </v-dialog>
          </v-card>
        </v-menu>
      </div>
    </div>

    <!-- Envoyées -->
    <div class="mb-10" v-if="sentRequests?.length">
      <h2 class="text-2xl font-bold mb-4">Demandes envoyées</h2>
      <div class="space-y-4">
        <div
          v-for="user in sentRequests"
          :key="user.id"
          class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow"
        >
          <div class="flex items-center ml-1">
            <v-img
              class="h-12 w-12 rounded-full"
              :src="'https://api.baranimes.com/images/minia/minori.png'"
              style="
                background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                  linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
              "
            ></v-img>

            <span class="text-[1rem] ml-3 max-w-[130px] line-clamp-1">{{ user.name }}</span>
          </div>
          <div class="flex gap-2">
            <button @click="cancelRequest(user)" class="bg-[#f54f67] text-white p-1 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="M7 21q-.825 0-1.412-.587T5 19V6q-.425 0-.712-.288T4 5t.288-.712T5 4h4q0-.425.288-.712T10 3h4q.425 0 .713.288T15 4h4q.425 0 .713.288T20 5t-.288.713T19 6v13q0 .825-.587 1.413T17 21zm5-7.1l1.9 1.9q.275.275.7.275t.7-.275t.275-.7t-.275-.7l-1.9-1.9l1.9-1.9q.275-.275.275-.7t-.275-.7t-.7-.275t-.7.275L12 11.1l-1.9-1.9q-.275-.275-.7-.275t-.7.275t-.275.7t.275.7l1.9 1.9l-1.9 1.9q-.275.275-.275.7t.275.7t.7.275t.7-.275z"
                />
              </svg>
            </button>
            <button class="bg-[#ffaf00] text-white px-4 py-1 rounded-lg" disabled>Envoyée</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Reçues -->
    <div class="mb-10" v-if="receivedRequests?.length">
      <div class="flex justify-between items-center mb-4">
        <h2 class="text-2xl font-bold">Demandes reçues</h2>
        <v-badge :content="receivedRequests.length" color="#f54f67" inline> </v-badge>
      </div>
      <div class="space-y-4">
        <div
          v-for="user in receivedRequests"
          :key="user.id"
          class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow"
        >
          <div class="flex items-center ml-1">
            <v-img
              class="h-12 w-12 rounded-full"
              :src="'https://api.baranimes.com/images/minia/minori.png'"
              style="
                background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                  linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
              "
            ></v-img>
            <span class="text-[1rem] ml-3 max-w-[170px] line-clamp-1">{{ user.name }}</span>
          </div>
          <div class="flex gap-2">
            <button @click="acceptRequest(user)" class="bg-linear text-white p-1 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <!-- Icon from Material Symbols by Google - https://github.com/google/material-design-icons/blob/master/LICENSE -->
                <path
                  fill="currentColor"
                  d="m9.55 15.15l8.475-8.475q.3-.3.7-.3t.7.3t.3.713t-.3.712l-9.175 9.2q-.3.3-.7.3t-.7-.3L4.55 13q-.3-.3-.288-.712t.313-.713t.713-.3t.712.3z"
                />
              </svg>
            </button>
            <button @click="refuseRequest(user)" class="bg-[#f54f67] text-white p-1 rounded-lg">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24">
                <!-- Icon from Bitcoin Icons by Bitcoin Design Community - https://github.com/BitcoinDesign/Bitcoin-Icons/blob/main/LICENSE-MIT -->
                <g fill="currentColor" fill-rule="evenodd" clip-rule="evenodd">
                  <path d="M5.47 5.47a.75.75 0 0 1 1.06 0l12 12a.75.75 0 1 1-1.06 1.06l-12-12a.75.75 0 0 1 0-1.06" />
                  <path d="M18.53 5.47a.75.75 0 0 1 0 1.06l-12 12a.75.75 0 0 1-1.06-1.06l12-12a.75.75 0 0 1 1.06 0" />
                </g>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-10" v-if="auth.user.role == 'admin'">
      <h2 class="text-2xl font-bold mb-4">Joueurs connectés</h2>
      <div class="space-y-4">
        <div
          v-for="(status, userId) in props.userStatuses"
          :key="userId"
          class="flex items-center justify-between bg-[#6d829b80] py-1 pr-4 rounded-3xl shadow"
        >
          <div class="flex items-center ml-1">
            <v-badge dot location="bottom end" :color="statusColors[status.dot]">
              <v-img
                class="h-12 w-12 rounded-full"
                :src="'https://api.baranimes.com/images/minia/minori.png'"
                style="
                  background: url('https://api.baranimes.com/images/global/bg_avatar.png') 0% 0% / cover,
                    linear-gradient(rgb(197, 197, 197), rgb(0, 140, 168));
                "
              ></v-img>
            </v-badge>

            <span class="text-[1rem] ml-3">{{ status.username }}</span>
          </div>
          <span>{{ status.path }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import {ref, computed, onMounted, reactive} from "vue";
  import {useJoinRoomStore} from "@/stores/joinRoom";
  import {useAuthStore} from "@/stores/auth";
  import {useGlobalStore} from "@/stores/global";
  const emit = defineEmits(["open-profil"]);

  const global = useGlobalStore();
  const statusColors = ["#90ee90", "#ffaf00", "#f54f67", "#808080"];
  const auth = useAuthStore();
  const props = defineProps({
    userStatuses: Object,
    myStatusRef: Number,
  });
  const joinRoom = useJoinRoomStore();
  const socket = joinRoom.socket;
  // const users = ref([]);
  const users = ref([
    {id: 1, name: "Alice", isFriend: false, requestSent: false, requestReceived: true},
    {id: 2, name: "Bob", isFriend: false, requestSent: true, requestReceived: false},
    {id: 3, name: "Charlie", isFriend: true, requestSent: false, requestReceived: false},
    {id: 4, name: "Diane", isFriend: true, requestSent: false, requestReceived: false},
    {id: 5, name: "Eric", isFriend: false, requestSent: false, requestReceived: false},
  ]);
  function openProfile(url) {
    emit("open-profil", url, 2);
    setTimeout(function () {
      document.getElementById("sidebar-right").classList.add("close");
    }, 1);
    setTimeout(function () {
      document.getElementById("sidebar-right").classList.remove("close");
    }, 200);
  }
  // Gestion des états individuels de chaque menu

  // Computed qui vérifie si au moins un menu est ouvert
  global.sidebar = computed(() => {
    return Object.values(menuStates).some(val => val);
  });

  const friends = computed(() =>
    users.value
      .filter(u => u.isFriend)
      .sort((a, b) => {
        // dot = 3 (ex: "offline") doit aller en dernier
        if (a.dot === 3 && b.dot !== 3) return 1;
        if (a.dot !== 3 && b.dot === 3) return -1;
        return 0;
      })
  );
  const menuStates = reactive({});
  friends.value.forEach(user => {
    menuStates[user.id] = false;
  });
  const sentRequests = computed(() => users.value.filter(u => u.requestSent && !u.isFriend));
  const receivedRequests = computed(() => users.value.filter(u => u.requestReceived && !u.isFriend));

  function acceptRequest(user) {
    socket.emit("friend:accept", {userId: user.id});
    user.isFriend = true;
    user.requestReceived = false;
  }

  function refuseRequest(user) {
    socket.emit("friend:refuse", {userId: user.id});
    user.requestReceived = false;
  }
  function removeFriend(user) {
    socket.emit("friend:remove", {userId: user.id});
    menuStates[user.id] = false;
    setTimeout(function () {
      user.isFriend = false;
    }, 1);
  }
  function cancelRequest(user) {
    socket.emit("friend:cancel", {userId: user.id});
    user.requestSent = false;
  }

  onMounted(() => {
    socket.emit("friend:list");
  });
  socket.on("friend:list:response", data => {
    users.value = data;
  });
  socket.on("friend:list:update", ({id, dot, online}) => {
    const user = users.value.find(u => u.id === id);
    if (user) {
      user.dot = dot;
      user.online = online;
    }
  });
  socket.on("friend:list:remove", ({id}) => {
    const user = users.value.find(u => u.id === id);
    if (user) {
      user.isFriend = false;
      user.requestReceived = false;
      user.requestSent = false;
    }
  });
  socket.on("friend:list:re", () => {
    socket.emit("friend:list");
  });

  socket.on("notification", data => {
    console.log("Notification reçue :", data);
    // Tu peux afficher une toast ou autre ici
  });
</script>

<style scoped>
  .disabled {
    filter: opacity(0.6);
    pointer-events: none;
  }
  .disabled div {
    filter: grayscale(1);
  }
</style>
